import IconCrossLarge from '@picsart/icons/IconCrossLarge';
import classNames from 'classnames';

import useStyles from './styles';
import { IAlert } from './types';

export function Alert({
  children,
  message,
  icon,
  className,
  variant = 'success',
  close = () => undefined,
}: IAlert) {
  const styles = useStyles({ variant });

  return (
    <div className={classNames(styles.root, className)}>
      <div className={styles.main}>
        {icon && <div className={styles.icon}>{icon}</div>}
        {(message || children) && (
          <div className={styles.message}>
            {message}
            {children}
          </div>
        )}
      </div>

      <button className={styles.btnClose} onClick={close}>
        <IconCrossLarge />
      </button>
    </div>
  );
}

export default Alert;
